<template>
    <div class="d-flex">
        <section class="pe-4" style="width: 100%">
            <h4 class="mb-2">Gebeurtenissen</h4>

            <!-- <div class="auto-layout">
                <div class="row">
                    <label>Datum</label>
                    <p>{{logitem.formatted_date}}</p>
                </div>
                <div class="row">
                    <label>URI</label>
                    <p>{{logitem.uri}}</p>
                </div>
                <div class="row">
                    <label>Module</label>
                    <p>{{logitem.controller}}</p>
                </div>
                <div class="row">
                    <label>Action</label>
                    <p>{{logitem.method}}</p>
                </div>
                <div class="row">
                    <label>User</label>
                    <p>{{logitem.user.first_name + ' ' + logitem.user.last_name}}</p>
                </div>
                <div class="row">
                    <label>User agent</label>
                    <p>{{logitem.user_agent}}</p>
                </div>
                <div class="row">
                    <label>IP</label>
                    <p>{{logitem.ip}}</p>
                </div>
            </div>

            <br>
            <h5>Gebeurtenissen</h5> -->
            <!--
              De waarden hieronder komen uit before_state en after_state, dus uit
              wat een gebruiker of een medewerker in het externe formulier ooit
              heeft ingevuld. Ze stonden hier met v-html: een naam of straat met
              een script erin werd uitgevoerd in de sessie van de HR-gebruiker
              die het log opende. Daarom gewone tekst. Een opgeslagen contract
              verschijnt daardoor als kale HTML-tekst in plaats van opgemaakt.
            -->
            <div v-for="event in logitem.logs" :key="event.id" style="border-bottom: 1px solid #dee2e6;" class="mb-2">

                <div class="auto-layout pt-2">
                    <div class="row">
                        <strong style="max-width: 100%;">{{event.formatted_log}}</strong>
                        
                    </div>
                </div>

                <template v-if="(event.diff_from && event.diff_from != '[]') || (event.diff_to && event.diff_to != '[]')">
                    <div class="row mb-2">
                        <div v-if="event.diff_from.length == 0" class="col-sm-12 col-form-label-sm">

                            <div class="auto-layout">
                                <div v-for="[key, value] in Object.entries(event.diff_to).filter(([k, v]) => v)" :key="key" class="row">
                                    <label>{{ key }}:</label>
                                    <p style="margin-bottom: 0px; padding-top: 3px;">{{ value }}</p>
                                </div>
                            </div>
                        </div>
                        <template v-else>
                            <div class="col-sm-6 col-form-label-sm">
                                Van:
                                <div class="auto-layout">
                                    <div v-for="[key, value] in Object.entries(event.diff_from).filter(([k, v]) => v)" :key="key" class="row">
                                        <label>{{ key }}:</label>
                                        <p style="margin-bottom: 0px; padding-top: 3px;">{{ value }}</p>
                                    </div>
                                </div>
                                
                            </div>
                            <div class="col-sm-6 col-form-label-sm">
                                Naar:
                                <div class="auto-layout">
                                    <div v-for="[key, value] in Object.entries(event.diff_to).filter(([k, v]) => v)" :key="key" class="row">
                                        <label>{{ key }}:</label>
                                        <p style="margin-bottom: 0px; padding-top: 3px;">{{ value }}</p>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </div>
                </template>

                <!-- <div class="row mb-2" v-if="(event.before_state && event.before_state != '[]') || (event.after_state && event.after_state != '[]')">
                    <div class="col-sm-6 col-form-label-sm">
                        Before <br>
                        <pre>{{event.before_state}}</pre>
                    </div>
                    <div class="col-sm-6 col-form-label-sm">
                        After <br>
                        <pre>{{event.after_state}}</pre>
                    </div>
                </div> -->
                <div class="col-sm-12 col-form-label-sm">
                    <pre class="w-100">{{event.additional_information}}</pre>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
    export default {
        name: 'LogDetail',
        data() {
            return {
                logitem: {
                    request_body: "",
                    user: {}
                }
            }
        },
        methods: {
            validate(){
                return true;
            },
            getData() {
                return this.logitem;
            },
            reset(){
                this.logitem = {
                    request_body: "",
                    user: {}
                };
            },
            setData(data){
                this.logitem = data;
                this.logitem.formatted_date = this.formatDate(this.logitem.created_at, 'dateTime');
                if(!this.logitem.user){
                    this.logitem.user = {first_name: "Gebruiker", last_name: "Onbekend"};
                }
            }
        }
    }

</script>
<style scoped>
    pre:not(.w-100) { max-width: 350px }
    pre.w-100 { max-width: 700px }
</style>